import { render, staticRenderFns } from "./u-lnb-all-border.vue?vue&type=template&id=c35e289c&scoped=true&"
import script from "./u-lnb-all-border.vue?vue&type=script&lang=js&"
export * from "./u-lnb-all-border.vue?vue&type=script&lang=js&"
import style0 from "./u-lnb-all-border.vue?vue&type=style&index=0&id=c35e289c&prod&lang=scss&"
import style1 from "./u-lnb-all-border.vue?vue&type=style&index=1&id=c35e289c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35e289c",
  null
  
)

export default component.exports